var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.3911V5.73779C0.5 4.90937 1.17157 4.23779 2 4.23779H8.42435C8.84697 4.23779 9.24998 4.41607 9.53426 4.72878L12.7632 8.28066C13.0142 8.55677 13.1533 8.91652 13.1533 9.28967V15.3911C13.1533 16.2196 12.4818 16.8911 11.6533 16.8911H2C1.17157 16.8911 0.5 16.2196 0.5 15.3911Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63333 2.89136L8.60443 2.45776C8.56595 1.88058 9.02375 1.39124 9.60222 1.39124L15 1.39124C15.5523 1.39124 16 1.83896 16 2.39124L16 6.99124L16 7.85791C16 8.41019 15.5523 8.85791 15 8.85791L14.5 8.85791",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.8167L4.59299 12.298C4.7203 12.616 5.12248 12.7147 5.38257 12.4918L6.92623 11.1686L9 9.39111",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.05e1fa4c7a4db1c9ad8f507e4dfb7dd1.svg";
export { ForwardRef as ReactComponent };